import React from "react";

export type ViewMode = "grid" | "alphabetical";

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  className?: string;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  onViewChange,
  className = "",
}) => {
  return (
    <div className={`flex bg-base-200 rounded-lg p-1 ${className}`}>
      <button
        onClick={() => onViewChange("grid")}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center gap-x-2 ${
          currentView === "grid"
            ? "bg-base-100 text-primary shadow-sm border border-base-300"
            : "text-base-content/70 hover:text-base-content hover:bg-base-300/50"
        }`}
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
        Grid
      </button>
      <button
        onClick={() => onViewChange("alphabetical")}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center gap-x-2 ${
          currentView === "alphabetical"
            ? "bg-base-100 text-primary shadow-sm border border-base-300"
            : "text-base-content/70 hover:text-base-content hover:bg-base-300/50"
        }`}
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 10h16M4 14h16M4 18h16"
          />
        </svg>
        A-Z
      </button>
    </div>
  );
};

export default ViewToggle;
